import { Component, Input, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap";
import { CBP7501 } from "../../../../objects/documents/CBP7501";
import { ValidationPatterns } from "../../../../common/helpers/ValidationPatterns";

@Component({
    selector: 'first-block-7501',
    templateUrl: 'first-block-7501.component.html',
    moduleId: module.id.toString()
})

export class FirstBlock7501Component{
    @Input()
    public document: CBP7501;

    @ViewChild("firstBlockForm")
    public firstBlockForm: NgForm;

    public numberPatternHelper = ValidationPatterns;

    public submitFormAndValidity(): boolean{
        this.firstBlockForm.onSubmit(null);

        return this.isFormValid();
    }

    public isFormValid(): boolean{
        return this.firstBlockForm.valid;
    }

}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-7501/document-blocks/first-block-7501.component.ts